import React from 'react';
import { VideoAndShowPDFAfter } from '../../body/VideoSlide';

const Distracting = () => {
  return (
    <div className='text-left p-4 space-y-6'>
      <VideoAndShowPDFAfter vidSrc={1194426137} />
    </div>
  );
};

export default Distracting;
